import { Notification } from "~/api/Api";
import { routes } from "~/router";

export function notificationPath(notification: Notification): string {
  const siteId = notification.site_id;

  switch (notification.kind) {
    case "site":
      return routes.site.root({ id: siteId });
    case "automation":
      return routes.site.onpage({ id: siteId });
    case "interlink":
      return routes.site.interlinks({ id: siteId });
    case "keyword":
      return routes.site.keywords.list({ id: siteId });
    case "keyword_import": {
      const importId = notification.notification_subjects?.[0]?.[0];

      return importId
        ? routes.site.keywords.import({ id: siteId, importId })
        : routes.site.keywords.imports({ id: siteId });
    }
    case "account":
      return routes.home();
  }
}
